// Sentry MUSS als allererstes importiert werden (vor React)
import "./lib/sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applyTheme } from "./lib/theme";
import "./index.css";

// Aggressiver SW-Cleanup: Deregistriere alle ServiceWorker die nicht zum Hub gehören.
// Notwendig nach Entfernung der Reporting-App (deren SW fängt Navigations-Requests ab).
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    for (const reg of regs) {
      // Hub-eigener SW lebt unter scope "/" — alle mit /reporting/ oder anderen
      // Satellite-Pfaden sind Relikte und müssen entfernt werden.
      const scope = reg.scope || "";
      if (scope.includes("/reporting")) {
        reg.unregister().then(() => console.log(`[sw-cleanup] unregistered: ${scope}`));
      }
    }
  });
}

// Theme vor Render setzen (FOUC-Schutz)
applyTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
